export default class NodeIcon {
  constructor({ nodeIconName = null } = {}) {
    if (this._isFunction(nodeIconName)) {
      this._nodeIconName = nodeIconName;
    } else {
      this._nodeIconName = () => nodeIconName;
    }
  }

  get key() {
    return 'nodeIcon';
  }

  _isFunction = item => typeof item === 'function';

  getNodeIconName(treeState, nodeId) {
    if (!this._nodeIconName && !treeState.models[nodeId]) {
      return null;
    }
    return this._nodeIconName(treeState.models[nodeId]);
  }
}
